/** Gợi ý triệu chứng (symptom quick-pick) client. Real /api/v1/symptom-suggestions — see SymptomSuggestionController. */
import { apiClient } from "./client";

/** Chip shape — active suggestions only. `id` is null for built-in defaults when the tenant has none. */
export interface SymptomOption {
  id: string | null;
  label: string;
}

/** Full row for the settings page (incl. inactive). */
export interface SymptomSuggestion {
  id: string;
  label: string;
  sortOrder: number;
  active: boolean;
}

export interface SymptomSuggestionCreateInput {
  label: string;
  sortOrder?: number | null;
}

export interface SymptomSuggestionUpdateInput {
  label: string;
  sortOrder?: number | null;
  active?: boolean | null;
}

export const symptomSuggestionsApi = {
  /** Active suggestions only, for the chip input. */
  options(): Promise<SymptomOption[]> {
    return apiClient
      .get<SymptomOption[]>("/v1/symptom-suggestions")
      .then((r) => r.data);
  },
  /** All suggestions (active + inactive) for the settings list. */
  listAll(): Promise<SymptomSuggestion[]> {
    return apiClient
      .get<SymptomSuggestion[]>("/v1/symptom-suggestions/all")
      .then((r) => r.data);
  },
  create(req: SymptomSuggestionCreateInput): Promise<SymptomSuggestion> {
    return apiClient
      .post<SymptomSuggestion>("/v1/symptom-suggestions", req)
      .then((r) => r.data);
  },
  update(id: string, req: SymptomSuggestionUpdateInput): Promise<SymptomSuggestion> {
    return apiClient
      .put<SymptomSuggestion>(`/v1/symptom-suggestions/${id}`, req)
      .then((r) => r.data);
  },
  disable(id: string): Promise<SymptomSuggestion> {
    return apiClient
      .post<SymptomSuggestion>(`/v1/symptom-suggestions/${id}/disable`)
      .then((r) => r.data);
  },
  enable(id: string): Promise<SymptomSuggestion> {
    return apiClient
      .post<SymptomSuggestion>(`/v1/symptom-suggestions/${id}/enable`)
      .then((r) => r.data);
  },
  /** Hard delete (permanent). */
  remove(id: string): Promise<void> {
    return apiClient
      .delete(`/v1/symptom-suggestions/${id}/permanent`)
      .then(() => undefined);
  },
  /** Nạp danh sách mặc định (idempotent — chỉ nạp khi danh mục trống). */
  seedDefaults(): Promise<SymptomSuggestion[]> {
    return apiClient
      .post<SymptomSuggestion[]>("/v1/symptom-suggestions/seed-defaults")
      .then((r) => r.data);
  },
};

export const symptomSuggestionQueryKeys = {
  options: () => ["symptom-suggestions", "options"] as const,
  all: () => ["symptom-suggestions", "all"] as const,
};
